<div class="pb-1 container-fluid" style="min-height: calc(var(--vh, 1vh) * 100 - 8.85rem)">
  <router-outlet></router-outlet>
</div>

<ng-container *ngIf="platform == 'web'">
  <div class="row p-3" style="background-color: #111; min-height: 16rem;">
    <div class="col-6 col-md-3">
      <a routerLink="/"><img alt="Nuuduu logo" i18n-alt src="assets/images/logo-text.webp"
          style="width: 9.5rem; position: relative; left: 0.4rem;" class="mb-3"></a>
      <a href="https://apps.apple.com/app/nuuduu/id6745711778" target="_blank"><img alt="Download on the App Store"
          i18n-alt src="assets/images/app-store.png" style="width: 9.5rem; display: block;" class="mb-3"></a>
      <a href="https://play.google.com/store/apps/details?id=com.nuuduu.customer" target="_blank"><img
          alt="Get it on Google Play" i18n-alt src="assets/images/play-store.png" style="width: 9.5rem; display: block;"
          class="mb-3"></a>
    </div>
    <div class="col-6 col-md-3 mb-3">
      <h5 i18n>Partner with Nuuduu</h5>
      <a [href]="'/partners/' + locale + '/find-work'" class="d-block" i18n>Find work</a>
      <a [href]="'/partners/' + locale + '/about'" class="d-block" i18n>What is Nuuduu for partners</a>
      <a [href]="'/partners/' + locale + '/signin'" class="d-block" i18n>Start working</a>
    </div>
    <div class="col-6 col-md-3 mb-3">
      <h5 i18n>Useful links</h5>
      <a routerLink="/" class="d-block" i18n>Discover services</a>
      <a routerLink="/about" class="d-block" i18n>What is Nuuduu for customers</a>
      <a routerLink="/signin" class="d-block" i18n>Sign in / Sign up</a>
      <a routerLink="/press" class="d-block" i18n>Press &amp; Media</a>
    </div>
    <div class="col-6 col-md-3">
      <h5 i18n>Follow us</h5>
      <a [href]="(organization | translateField: 'customer_youtube_link') || environment.default_youtube_channel_link" target="_blank"
        class="d-block">YouTube</a>
      <a [href]="(organization | translateField: 'customer_facebook_link') || environment.default_facebook_link" target="_blank"
        class="d-block">Facebook</a>
      <a [href]="(organization | translateField: 'customer_x_link') || environment.default_x_link" target="_blank"
        class="d-block">X</a>
    </div>
  </div>
  <div class="row p-3 align-items-center" style="background-color: #111;">
    <div class="col-4">
      <a (click)="languageSelector()" class="nav-link cursor-pointer" data-bs-dismiss="offcanvas">
        <ng-container *ngIf="organization && organization.country_code">
          <img [alt]="organization | translateField: 'country'"
            [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'"
            style="height: 1rem; border: none; position: relative; top: -1px;" class="me-1">
          {{ locale | i18nSelect: locales }}
        </ng-container>
        <ng-container *ngIf="!organization">
          <fa-icon [icon]="fa.faGlobe" style="color:#fff;"></fa-icon>&nbsp;
          <ng-container i18n>Location</ng-container>
        </ng-container>
      </a>
    </div>
    <div class="col-8 text-end">
      <a href="https://nuuduu.com/privacy" (click)="privacyPolicy(); $event.preventDefault();" i18n>Privacy
        policy</a>&nbsp;&nbsp;
      <a href="https://nuuduu.com/tnc" (click)="tnc(); $event.preventDefault();" i18n>Terms &amp;
        conditions</a>&nbsp;&nbsp;
        <span class="text-nowrap">&copy; Nuuduu UAB {{ copyrightYear }}</span>
    </div>
  </div>
</ng-container>